// extracted by mini-css-extract-plugin
export default {"default":"default-SLv2","icon":"icon-LxA9","enabled":"enabled-bNBT","dropbox":"dropbox-VlkR","gdrive":"gdrive-FpBP"};